module.exports = __webpack_public_path__ + "static/media/img-logo-menu.4efb53fd.svg";